export const API_ROOT =
  process.env.NODE_ENV === "production"
    ? "https://sem.schwarzl-it.com/api/"
    : "http://localhost:8080/";
export const WS_ROOT =
  process.env.NODE_ENV === "production"
    ? "https://obs.schwarzl-it.com/"
    : "http://localhost:8111/";
